import React from 'react';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
    icon: {
        marginRight: 4
    },
    root: {
        display: 'flex',
        flexFlow: 'column nowrap',
        padding: 4,
        marginTop: 24,
        alignItems: 'center'
    },
    fab: {
        // position: 'absolute',
        // bottom: theme.spacing(2),
        right: 0,
        left: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '208px !important',
        zIndex: 10
    },
    pushButton: {
        marginBottom: '1rem'
    }
});

export default withStyles(styles)(function PushPropertyButtons({
    loading,
    onPushPropertyClicked,
    classes,
    disabled
}) {
    // const disabled = loading === true;
    const buttonText = loading ? null : 'Submit Prospect';
    const icon =
        loading === true ? (
            <CircularProgress size={24} color="primary" />
        ) : (
            <AddIcon className={classes.icon} />
        );

    return (
        <div className={classes.pushButton}>
        <Fab
            variant="extended"
            color="primary"
            size="medium"
            disabled={loading === true || disabled}
            className={classes.fab}
            onClick={onPushPropertyClicked}
        >
            {icon}
            {buttonText}
        </Fab>
        </div>
    );
});
